import { Alert as FlowbiteAlert } from 'flowbite-react';
import { AlertTypes } from '../../data/options';

const Alert = ({alert, setAlert}) => {
    const msgParser = (msg) => {
        let parsedMsg = msg
        if (msg.includes('401')) parsedMsg = 'Not authorized, please login to continue.'
        return parsedMsg
    }

    const customTheme = {
        closeButton: {
            base: "ml-1 inline-flex h-6 w-6 p-1 focus:ring-2",
            icon: "h-4 w-4",
        },
        icon: "inline h-4 w-4 shrink-0 mr-2"
    };

    const alertType = alert.type || AlertTypes.INFO;
    const style = alertType.style || AlertTypes.INFO.style;
    const IconComponent = alertType.icon || AlertTypes.INFO.icon;

    if (!alert.visible) return null;

    return (
        <FlowbiteAlert
            color={style}
            icon={IconComponent}
            onClick={() => setAlert ? setAlert({...alert, visible: false}) : null}
            className={`mt-4 rounded-md px-3 py-1 min-w-0 max-w-full ${alert.className || ''}`}
            theme={customTheme}
        >
            <span className="font-medium break-words">{msgParser(alert.msg)}</span>
        </FlowbiteAlert>
    )
}

export default Alert
